import {withFormik} from "formik";
import compose from "recompose/compose";
import Style from "@xem/qr-client-react/helpers/popup/bgSettings/Style";
import withProps from "recompose/withProps";

/**
 * DataForm
 */
export const DataForm = withFormik({
	enableReinitialize: true,
	displayName: `BankForm`,
	handleSubmit: async (values, { props }) => {},
	mapPropsToValues: ({ values }: any) => {
		return {...values }
	}
});


export default compose(
	Style,
	DataForm,
);